/*
 * Shopify Dawn Theme - animations.js (Standard 102 lines)
 */

const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-reveal';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

function onIntersection(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const target = entry.target;
      if (target.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        target.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (target.hasAttribute('data-cascade')) {
          target.setAttribute('data-cascade', 'true');
        }
      }
      target.classList.add('scroll-trigger--visible');
      observer.unobserve(target);
    }
  });
}

const initializeScrollAnimations = () => {
  const scrollReleaseElements = document.querySelectorAll(`.${SCROLL_ANIMATION_OFFSCREEN_CLASSNAME}`);
  const scrollTriggerElements = Array.from(document.querySelectorAll(`.${SCROLL_ANIMATION_TRIGGER_CLASSNAME}`));

  if (scrollTriggerElements.length === 0 && scrollReleaseElements.length === 0) return;

  const observerOptions = {
    rootMargin: '0px 0px -50px 0px',
    threshold: [0, 0.1, 1],
  };

  const observer = new IntersectionObserver(onIntersection, observerOptions);

  scrollTriggerElements.forEach((element) => {
    if (element.classList.contains(SCROLL_ANIMATION_CANCEL_CLASSNAME)) return;
    observer.observe(element);
  });

  scrollReleaseElements.forEach((element) => {
    observer.observe(element);
  });
};

const initializeZoomAnimations = () => {
  const zoomElements = Array.from(document.querySelectorAll('.image-magnify-full-size'));
  if (zoomElements.length === 0) return;

  zoomElements.forEach((element) => {
    element.addEventListener('click', (event) => {
      event.currentTarget.classList.toggle('image-magnify-full-size--active');
    });
  });
};

// Menu Drawer Animations
const initializeMenuAnimations = () => {
  const menuDrawers = document.querySelectorAll('menu-drawer');
  if (menuDrawers.length === 0) return;

  menuDrawers.forEach((drawer) => {
    drawer.addEventListener('details-toggle', (event) => {
      const summary = event.target.querySelector('summary');
      if (event.detail.open) {
        summary.setAttribute('aria-expanded', 'true');
      } else {
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  });
};

// Hover effect for product cards
const initializeHoverAnimations = () => {
  const cards = document.querySelectorAll('.card-wrapper');
  cards.forEach((card) => {
    card.addEventListener('mouseenter', () => {
      const image = card.querySelector('.card__inner img');
      if (image) image.style.transform = 'scale(1.05)';
    });
    card.addEventListener('mouseleave', () => {
      const image = card.querySelector('.card__inner img');
      if (image) image.style.transform = 'scale(1)';
    });
  });
};

// Master init
document.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimations();
  initializeZoomAnimations();
  initializeMenuAnimations();
  initializeHoverAnimations();
});

/* Fin del archivo original de 102 líneas aproximadamente */